import styles from "./system.module.scss";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Icon from "components/icon/icon";
import { LeftPanel } from "helpers/constants";
import { AppContext, setLeftPanel } from "helpers/context";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import AnalysisReport from "./report/addressAnalysisReport/analysisReport";
import LoginReport from "./report/login-report/login-report";
import Role from "./role/role";
import Message from "./message/message";
import Tenant from "./tenant/tenant";
import User from "./user/user";
import EndPoint from "./apiManagement/endPoint//endPoint";
import Client from "./apiManagement/client/client";
import Key from "./apiManagement/key/key";
import Bill from "./apiManagement/bill/bill";
import Group from "./apiManagement/group/group";
import Scope from "./apiManagement/scope/scope";
import ApiReport from "./apiManagement/apiReport/apiReport";

const menulist = [
	{
		title: "租户管理",
		id: "tenant",
	},
	{
		title: "用户管理",
		id: "user",
	},
	{
		title: "角色管理",
		id: "role",
	},
  {
    title: "消息管理",
    id: "message",
  },
	{
		title: "报表",
		id: "report",
		children: [
			{
				title: "登录报表",
				id: "loginReport",
			},
			{
				title: "操作分析报表",
				id: "addressAnalysisReport",
			},
		],
	},
	{
		title: "api管理",
		id: "apiManagement",
		children: [
			{
				title: "Client管理",
				id: "client",
			},
			{
				title: "Key管理",
				id: "key",
			},
			{
				title: "Bill管理",
				id: "bill",
			},
			{
				title: "EndPoint管理",
				id: "endPoint",
			},
			{
				title: "EndPointGroup管理",
				id: "endPointGroup",
			},
			{
				title: "EndPointScope管理",
				id: "endPointScope",
			},
			{

				title: "报表",
				id: "apiReport",
			}
		]
	}
];

const renderComponent: { [key: string]: React.FunctionComponent<any> } = {
	tenant: Tenant,
	user: User,
	role: Role,
  message: Message,
	loginReport: LoginReport,
	addressAnalysisReport: AnalysisReport,
	client: Client,
	key: Key,
	bill: Bill,
	endPoint: EndPoint,
	endPointGroup: Group,
	endPointScope: Scope,
	apiReport: ApiReport,
};

function System() {
  const [context, dispatch] = useContext(AppContext);
  const [activeMenu, setActiveMenu] = useState("tenant");
  const [t] = useTranslation();
  const CurrentComponent = renderComponent[activeMenu];

  return (
    <div className={styles.system}>
      <div className={styles.title}>
        <div>{t("userSystem.title")}</div>
        <div>
          <Icon onClick={() => setLeftPanel(dispatch, LeftPanel.Empty)} />
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles.leftContent}>
					<div className="text-[16px] font-medium">{t("userSystem.management")}</div>
					<div className="mt-[10px] overflow-auto">
						{menulist.map((menu, index) => {
							let childrenMenuIds = menu.children ? menu.children.map(child => child.id) : [];
							return (menu.children ? (
                <Accordion
                  key={index}
                  sx={{
                    boxShadow: "none",
                    backgroundColor: "transparent",
                    margin: "0!important",
                    "&::before": {
                      display: "none",
                    },
                  }}
                >
                  <AccordionSummary
                    expandIcon={
                      <div
                        className="material-icons"
												style={{ color: childrenMenuIds.includes(activeMenu) ? "#007934" : "#666" }}
                      >
                        keyboard_arrow_right
                      </div>
                    }
                    sx={{
                      padding: "0 18px",
											color: childrenMenuIds.includes(activeMenu) ? "#007934" : "#666",
                      fontSize: "14px",
                      fontWeight: 500,
                      margin: 0,
                      minHeight: "40px",
                      "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
                        transform: "rotate(90deg)",
                      },
                      "& .MuiTypography-root": {
                        fontFamily: "Roboto-Regular",
                      },
                      "&.Mui-expanded": {
                        minHeight: "40px",
                      },
                      "& .MuiAccordionSummary-content": {
                        margin: "8px 0",
                      },
                      "& .MuiAccordionSummary-content.Mui-expanded": {
                        margin: "8px 0",
                      },
                    }}
                  >
                    {t("userSystem." + menu.id)}
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{
                      padding: "6px 0 0",
                      width: "100%",
                    }}
                  >
                    <div className="bg-[#F8F8F8] p-[10px]">
                      {menu.children.map((subMenu) => (
                        <div
													className={`${styles.menuItem} ${activeMenu === subMenu.id ? styles.active : ""}`}
                          onClick={() => {
                            setActiveMenu(subMenu.id);
                          }}
                          key={subMenu.id}
                        >
                          {t("userSystem." + subMenu.id)}
                        </div>
                      ))}
                    </div>
                  </AccordionDetails>
                </Accordion>
              ) : (
                <div
									className={`${styles.menuItem} ${activeMenu === menu.id ? styles.active : ""}`}
                  onClick={() => {
                    setActiveMenu(menu.id);
                  }}
                  key={index}
                >
                  {t("userSystem." + menu.id)}
                </div>
              ))
            })}
          </div>
        </div>
        <div className={styles.rightContent}>
          <CurrentComponent />
        </div>
      </div>
    </div>
  );
}

export default System;
